module.exports = __webpack_public_path__ + "static/img/44.00ef8c19.gif";